const LOADING_TEXT: Record<string, string> = {
  da: 'Loading...',
  de: 'Loading...',
  en: 'Loading...',
  en_US: 'Loading...',
  es: 'Loading...',
  fi: 'Ladataan...',
  fr: 'Loading...',
  fr_CA: 'Loading...',
  it: 'Loading...',
  ja: 'Loading...',
  nl: 'Loading...',
  no: 'Loading...',
  pl: 'Loading...',
  pt: 'Loading...',
  sv: 'Loading...',
  tr: 'Loading...',
  zh: 'Loading...',
};

function getLoadingText(): string {
  const lang = (localStorage.getItem('spartacus⚿⚿language') || 'en').replace(/"/g, '').replace('-', '_'); // normalize en-US -> en_US

  // Try exact match first (en_US, fr_CA, etc.)
  if (LOADING_TEXT[lang]) return LOADING_TEXT[lang];

  // Fallback to base language (en_US -> en)
  const base = lang.split('_')[0];
  return LOADING_TEXT[base] || LOADING_TEXT.en;
}

export function showOAuthLoadingOverlay(): void {
  if (document.getElementById('oauth-loading-overlay')) return;

  const overlay = document.createElement('div');
  overlay.id = 'oauth-loading-overlay';
  overlay.innerHTML = `
    <div class="oauth-spinner">
      <span class="spinner-icon"></span>
      <i><p>${getLoadingText()}</p></i>
    </div>
  `;

  document.body.appendChild(overlay);
}

export function removeOAuthLoadingOverlay(): void {
  document.getElementById('oauth-loading-overlay')?.remove();
}
